export default function ChangePasswordForm() {
    return {
        restrict: "E",
        scope: {
            form: "=",
            userId: "<",
            validation: "=",
            required: "=",
            label: "=",
        },
        template: require("./template.html"),

        controller: function ($scope, UserService, PasswordReqEx, ENV) {
            $scope.debug = ENV.debug;
            $scope.passwordReqEx = PasswordReqEx;
            $scope.stringOfIllegalChars = "";

            $scope.displayForm = true;

            $scope.status = {
                error: null,
                success: null,
            };

            $scope.changePassword = (userId, password) => {
                /**
                 * Any form validation errors ?
                 */
                if (!Object.keys($scope.form.$error).length) {
                    /**
                     * Api PUT
                     *                      */
                    UserService.changePassword(userId, password).then(
                        (res) => {
                            $scope.status = {
                                error: false,
                                success: true,
                            };

                            $scope.displayForm = false;
                        },
                        (err) => {
                            $scope.status = {
                                error: true,
                                success: false,
                            };

                            $scope.displayForm = false;
                        }
                    );
                } else {
                    // console.log("not allowed");
                }
            };
        },
    };
}
